import { component } from 'picoapp'
import { formatMoney } from '../lib/currency'

export default component((node, app) => {
    const missingElement = node.querySelector('[data-amount]')
    const progressElement = node.querySelector('[data-progress]')
    const grantedContent = node.querySelectorAll('[data-granted]')
    const notGrantedContent = node.querySelectorAll('[data-not-granted]')

    const threshold = parseInt(node.dataset.conditionThreshold, 10)

    app.on('cart:updated', ({ cart }) => {
        let missing
        let isGranted = false
        let progress

        missing = Math.max(threshold - cart.total_price, 0)
        if (cart.total_price >= threshold && cart.item_count > 0) {
            isGranted = true
        }

        missingElement.textContent = formatMoney(missing)

        progress = Math.min((cart.total_price / threshold) * 100, 100)
        progressElement.style.setProperty('--width', `${progress.toString()}%`)

        if (isGranted) {
            progressElement.classList.add('gwp__bar-fill--filled')
        } else {
            progressElement.classList.remove('gwp__bar-fill--filled')
        }

        grantedContent.forEach((element) => {
            element.hidden = !isGranted
        })

        notGrantedContent.forEach((element) => {
            element.hidden = isGranted
        })
    })
})
